export default __webpack_public_path__ + "static/media/github.6ae876b7.png";